import { useMemo } from 'react';

import { useUser } from '@clerk/react';

import {
  buildSignatureBlock,
  resolveEmailSignatureConfig,
} from '../../utils/emailSignature';

export function useComposeSignatureBlock(): string {
  const { user } = useUser();
  const { enabled, html } = resolveEmailSignatureConfig(user?.unsafeMetadata);

  return useMemo(
    () => (enabled ? buildSignatureBlock(html) : ''),
    [enabled, html],
  );
}
